exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-795eaa9e] {\n  font-weight: 400;\n  font-size: 14px;\n  text-transform: none;\n  letter-spacing: normal;\n  border-radius: 4px;\n  padding: 2px 4px;\n}\n.status.small[data-v-795eaa9e] {\n  padding: 4px;\n  font-weight: bold;\n  border-radius: 4px;\n  font-size: 8.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}", ""]);

// exports
